import { useEffect, useState } from "preact/hooks";

export interface Route {
  path: string;
  name: "home" | "mint" | "portfolio" | "detail" | "editor" | "demo" | "install" | "developers" | "privacy" | "support" | "about" | "sales" | "box" | "designer" | "qurl" | "notFound";
  qyoo?: number;
}

export function parseRoute(pathname: string): Route {
  if (pathname === "/app") return {path: pathname, name: "install"};
  if (pathname === "/examples") return {path: pathname, name: "demo"};
  if (["/about", "/sales", "/box", "/designer"].includes(pathname)) return {path: pathname, name: pathname.slice(1) as Route["name"]};
  const qurl = /^\/q\/(0|[1-9][0-9]{0,10})$/.exec(pathname);
  if (qurl && Number(qurl[1]) <= 68719476735) return {path: pathname, name: "qurl", qyoo: Number(qurl[1])};
  if (["demo", "install", "developers", "privacy", "support"].includes(pathname.slice(1))) return {path: pathname, name: pathname.slice(1) as Route["name"]};
  if (pathname === "/") return { path: pathname, name: "home" };
  if (pathname === "/mint") return { path: pathname, name: "mint" };
  if (pathname === "/my-qyoos") return { path: pathname, name: "portfolio" };
  const editor = /^\/qyoo\/(\d+)\/edit$/.exec(pathname);
  if (editor) return { path: pathname, name: "editor", qyoo: Number(editor[1]) };
  const detail = /^\/qyoo\/(\d+)$/.exec(pathname);
  if (detail) return { path: pathname, name: "detail", qyoo: Number(detail[1]) };
  return { path: pathname, name: "notFound" };
}

export function useRouter() {
  const [route, setRoute] = useState(() => parseRoute(window.location.pathname));
  useEffect(() => {
    const update = () => setRoute(parseRoute(window.location.pathname));
    window.addEventListener("popstate", update);
    return () => window.removeEventListener("popstate", update);
  }, []);
  const navigate = (path: string) => {
    if (path === window.location.pathname) return;
    window.history.pushState({}, "", path);
    setRoute(parseRoute(path));
    window.scrollTo({ top: 0, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  };
  return { route, navigate };
}
